import { z } from "zod";

// Define the ChecklistItemAPI schema
const ChecklistItemSchema = z.object({
  id: z.number(),
  description: z.string().nullable(),
  comment: z.string().nullable(),
  comment_by: z.string().nullable(),
  comment_date: z.string().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  checked_by: z.string().nullable(),
  checked_date: z.string().nullable(),
  image_url: z.string().nullable(),
  thumbnail_url: z.string().nullable(),
  board_id: z.number()
});

// Define the main response schema based on the Swagger specification
export const ChecklistResponseSchema = z.object({
  id: z.number(),
  entity_title: z.string().nullable(),
  checklist_title: z.string().nullable(),
  type: z.number(),
  order: z.number().min(0).max(2147483647),
  created_at: z.string(),
  updated_at: z.string(),
  creator: z.number().nullable(),
  updater: z.number().nullable(),
  archived: z.boolean(),
  board: z.number(),
  resource: z.number().nullable(),
  client: z.number().nullable(),
  task: z.number().nullable(),
  nudge_date: z.string().nullable(),
  can_edit_grant: z.number(),
  can_view_grant: z.number(),
  assigned_boardusers: z.array(z.string().nullable()),
  has_permission: z.boolean(),
  total_items: z.number(),
  items_left: z.number(),
  items: z.array(ChecklistItemSchema)
});
